import {
	createStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const styles = (theme: Theme) => {
	return createStyles({
		pagination_actions: {
			display: 'flex',
			marginLeft: theme.spacing(3),
		},
		pagination_container: {

		},
		pagination_mobileContainer: {
			display: 'flex',
			justifyContent: 'center',
			margin: theme.spacing(2, 0, 1, 0),
		},
		pagination_spacer: {
			flex: '1 0',
		},
		pagination_toolbar: {
			flexWrap: 'wrap',
		}
	});
}

export default styles;
